<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@tixxSelect.sectionHeading.eventDetails' class="esf-action-heading__text">Event details</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              [disabled]="!(selectedLottery.isDraftMode || selectedLottery.isEditMode)"
              (click)="editLotteryDetails();$event.stopPropagation();"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16" *ngIf="editable">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">
    <h6 class="competition">
      {{ selectedLottery.event.competition }}
    </h6>
    <h4 class="name" style="padding-top: 0">
      {{ selectedLottery.event.name }}
    </h4>

    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <svg class="esf-icon" width="16" height="16">
        <use xlink:href="#esf-icon-location-small"></use>
      </svg>
      <div class="esf-icon-and-text__text venue">{{ selectedLottery.event.venue }}</div>
    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <svg class="esf-icon" width="16" height="16">
        <use xlink:href="#esf-icon-calendar"></use>
      </svg>
      <div class="esf-icon-and-text__text date">{{ selectedLottery.event.date.date | date:selectedLottery.event.date.format }}</div>
    </div>
  </div>
</div>
